import { Progress } from "antd";
import "./porcentagem-aulas.css";
import { boxTurmaInformacaoStore } from "../../store/box-turma-informacao.store";
import { TFunction } from "i18next";

export default function PorcentagemAulas({t}: {t: TFunction<["gestao_de_aulas", "common"], undefined>}) {
  const {
    boxTurmaInformacao: {
      quantidadeAulas,
      porcentagemAulasRealizadas,
      quantidadeAulasRealizadas,
    },
  } = boxTurmaInformacaoStore();

  return (
    <div className="porcentagem-aulas">
      <Progress
        type="circle"
        percent={porcentagemAulasRealizadas}
        size={80}
        strokeColor="var(--primary-color)"
        trailColor="rgba(203, 212, 237, 0.2)"
      />
      <div className="porcentagem-aulas__andamento-aulas">
        <h3 className="andamento-aulas__titulo">{t('gestao_de_aulas:inProgress')}</h3>
        <h6 className="andamento-aulas__subtitulo">
          {quantidadeAulasRealizadas} de {quantidadeAulas} aulas
        </h6>
      </div>
    </div>
  );
}
